import { useEffect, useState } from "react";
import { Phone } from "lucide-react";
import { PHONE, PHONE_HREF, scrollToIntake } from "../../lib/erg";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "bg-erg-deep/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className={`mx-auto max-w-6xl px-5 sm:px-8 flex items-center justify-between gap-3 transition-[height] duration-500 ${scrolled ? "h-14" : "h-16"}`}>
        <button
          data-testid="brand-wordmark"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5 text-left"
        >
          <span className="grid place-items-center h-8 w-8 rounded-[6px] bg-erg-aqua/15 border border-erg-aqua/40">
            <span className="h-2.5 w-2.5 rounded-full bg-erg-aqua" />
          </span>
          <span className="leading-none">
            <span className="block font-display font-bold tracking-wide text-erg-dry text-[15px] uppercase">
              <span className="sm:hidden">ERG</span>
              <span className="hidden sm:inline">Emergency Response Group</span>
            </span>
            <span className="block font-mono text-[10px] text-erg-aqua/80 tracking-[0.2em] uppercase">
              Water · Fire · Restoration
            </span>
          </span>
        </button>

        <div className="flex items-center gap-2 sm:gap-3">
          <a
            data-testid="header-phone-link"
            href={PHONE_HREF}
            className="hidden sm:inline-flex items-center gap-2 text-erg-dry/90 hover:text-erg-aqua transition-colors duration-300 font-mono text-[13px]"
          >
            <Phone className="h-4 w-4" strokeWidth={2} />
            {PHONE}
          </a>
          <button
            data-testid="header-intake-cta"
            onClick={scrollToIntake}
            className="inline-flex items-center rounded-full bg-erg-ember px-4 sm:px-6 py-2 sm:py-3 font-display font-semibold uppercase tracking-wide text-erg-ink text-sm sm:text-base hover:brightness-105 active:scale-[0.98] transition-[transform,filter] duration-200 ember-pulse"
          >
            Get help now
          </button>
        </div>
      </div>
    </header>
  );
};
